import {makeStyles} from 'tss-react/mui';

const useStyles = makeStyles()((theme, _params, classes) => ({
  root: {},
  treeContainer: {
    position: 'absolute',
    /*    width: "100%",*/
    overflow: 'hidden',
    backgroundColor: '#F9F9FB',
    backgroundImage: "url('/img/background/bg-context-tree.png')",
    backgroundRepeat: "repeat",
    userSelect: "none",
    height: '400px',
    [`&.${classes.fullScreen}`]: {
      position: 'relative',
      height: '100%'
    },
  },
  zoomPanel: {
    position: 'absolute',
    zIndex: 1000,
    display: 'flex',
    flexDirection: 'column',
    right: 10,
    bottom: 10,
    '& svg': {
      cursor: 'pointer',
    }
  },
  deleteNodeButton: {
    position: 'absolute',
    top: '8px',
    right: '8px',
    color: theme.palette.grey.grey100,
    background: theme.palette.grey.grey500,
    borderRadius: '50%',
    width: '20px',
    height: '20px',
    padding: '2px'
  },
  toolBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    position: 'relative',
    zIndex: 100,

    width: 'calc(100% - 12px)',
    border: '2px solid #FFF',
    background: 'linear-gradient(113deg, rgba(255, 255, 255, 0.66) 0%, rgba(255, 255, 255, 0.64) 110.84%)',
    backdropFilter: 'blur(2px)',
    margin: '6px',
    padding: '14px 20px 16px 20px'
  },
  legendContainer: {
    position: 'absolute',
    zIndex: 1000,
    top: '83px',
    left: '6px',
    height: 'auto',
    width: '148px',
    borderRadius: "10px",
    border: "1px solid #FFF",
    background: "linear-gradient(113deg, rgba(255, 255, 255, 0.66) 0%, rgba(255, 255, 255, 0.64) 110.84%)",
    padding: '6px 13px'
  },
  legendTitle: {
    fontSize: '10px',
    fontWeight: '700',
    color: theme.palette.grey.grey400
  },
  legend: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '12px',
    color: theme.palette.black.dark,
    marginTop: '8px'
  },
  legendSquareOrange: {
    background: theme.palette.warning.warning500,
    height: '8px',
    width: '8px',
    marginRight: '4px'
  },
  legendSquareBlue: {
    background: '#0059FF',
    height: '8px',
    width: '8px',
    marginRight: '4px'
  },
  legendSquareViolet: {
    background: '#6D00CC',
    height: '8px',
    width: '8px',
    marginRight: '4px'
  },

}));

export default useStyles;
